import Router from "@/route";

export function resolveMonitorTarget(driver) {
  if (!driver) {
    return null;
  }
  if (driver.newVideoDeviceId) {
    return {
      path: "/video/zhijia",
      deviceNo: driver.newVideoDeviceId,
      driverId: driver.id,
      deviceType: "zhijia"
    };
  }
  if (driver.videoDeviceId) {
    return {
      path: "/video/monitor",
      deviceNo: driver.videoDeviceId,
      driverId: driver.id,
      deviceType: "tongtianxing"
    };
  }
  return null;
}

export function openDriverMonitor(driver) {
  const target = resolveMonitorTarget(driver);
  if (!target) {
    return "没有监控设备";
  }
  const { href } = Router.resolve({
    path: target.path,
    query: { deviceNo: target.deviceNo, driverId: target.driverId }
  });
  window.open(href, "_blank");
  return "";
}
